
import { useToast } from "@/hooks/use-toast";
import { clearAuthData } from './authUtils';
import { User } from './types';
import { useNavigate } from 'react-router-dom';

export const useLogout = (
  setUser: (user: User | null) => void, 
  setToken: (token: string | null) => void
) => {
  const { toast } = useToast();
  const navigate = useNavigate();

  const logout = () => {
    clearAuthData();
    setToken(null);
    setUser(null);
    
    toast({
      title: "Kijelentkezés",
      description: "Sikeresen kijelentkezett.",
    });
    
    // Navigate to homepage after logout with state indicating we came from logout
    navigate('/', { state: { fromLogout: true } });
  };

  return { logout };
};
